import { makeApi } from "@zodios/core";
import { z } from "zod";

import { installSatisfactionApplianceInstalledDtoSchema } from "@/types/backoffice/dto/survey/install-satisfaction/install-satisfaction-appliance-installed-dto.ts";
import { surveyInterventionDtoSchema } from "@/types/backoffice/dto/survey/survey-intervention-dto.ts";

export const backofficeSurveyApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/interventions",
    response: z.array(surveyInterventionDtoSchema),
    alias: "findSiteSurveyInterventions",
  },
  {
    method: "post",
    path: "/site/:siteId/install-satisfaction",
    response: z.any(),
    alias: "sendInstallSatisfactionSurvey",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: z.object({
          appliancesInstalled: installSatisfactionApplianceInstalledDtoSchema,
          generalComment: z.string(),
          installationCleanliness: z.number(),
          interventionId: z.number(),
          promptness: z.number(),
          solutionExplanation: z.number(),
          subscriberRecommendsSolution: z.number().nullable(),
          technicianKindness: z.number(),
          technicianProfessionalism: z.number(),
        }),
      },
    ],
  },
]);
